module.exports = __webpack_public_path__ + "img/awards.ace4761.png";